import React, { useEffect, useState } from 'react';
import {
  Box, Grid, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TablePagination, Button
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import useUsers from '../../Hooks/useUsers';
import { decryptedBody, decryptData, DESCRYPTION_TYPE } from '../../Utils/constant';
import moment from 'moment';
import PageHeader from "../../Components/UI/PageHeader";
import SectionCard from "../../Components/UI/SectionCard";

const ArchivedUsers = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  const { archiveUser } = useUsers();

  useEffect(() => {
    fetchArchivedUsers();
  }, []);

  // const fetchArchivedUsers = async () => {
  //   const temp = await archiveUser();
  //   // const res = decryptedBody(temp.data.data);
  //   const res = temp.data.data;
  //   setUsers(res);
  // };
  const safeDecrypt = (value) => {
  try {
    return decryptData(value, DESCRYPTION_TYPE.STRING);
  } catch {
    return value;
  }
};
  const fetchArchivedUsers = async () => {
  const temp = await archiveUser();

  const res = temp?.data?.data.map((user) => ({
    ...user,
    firstname: safeDecrypt(user.firstname),
    lastname: safeDecrypt(user.lastname),
    email: safeDecrypt(user.email),
    phone: safeDecrypt(user.phone),
    barcode: safeDecrypt(user.barcode),
    deviceName: safeDecrypt(user.deviceName),
  }));

  setUsers(res);
};

  const paginatedUsers = users.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <PageHeader
        title="Archived users"
        subtitle="Users who were archived/deleted along with their delete reason."
        actions={[
          { label: "Active users", key: "active", onClick: () => navigate("/app-users") },
        ]}
      />

      <SectionCard title="Archived list" subtitle={`Total: ${users.length}`}>
        <Box sx={{ overflowX: "auto" }}>
          <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
            <Table stickyHeader sx={{ minWidth: 900 }}>
              <TableHead>
                <TableRow>
                  {[
                    "Firstname",
                    "Lastname",
                    "Email",
                    "Phone",
                    "Delete Reason",
                    "Archived At",
                  ].map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 800 }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedUsers.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>{row.firstname}</TableCell>
                    <TableCell>{row.lastname}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.phone}</TableCell>
                    <TableCell>{row.deleteReason}</TableCell>
                    <TableCell>{moment(row.createdAt).format("LLL")}</TableCell>
                  </TableRow>
                ))}
                {users.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No archived users found.
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={users.length}
            page={currentPage}
            onPageChange={(e, newPage) => setCurrentPage(newPage)}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[10]}
          />
        </Box>
      </SectionCard>
    </Box>
  );
};

export default ArchivedUsers;